"use strict";var ComponentDef = require("../../../runtime/components/ComponentDef");

module.exports = function beginComponent(
componentsContext,
component,
key,
ownerComponentDef)
{
  var componentId = component.id;
  var componentDef = componentsContext.n_ = new ComponentDef(
    component,
    componentId,
    componentsContext
  );
  componentsContext.o_.p_[
  componentId] =
  true;
  componentsContext.b_.push(componentDef);

  var out = componentsContext.q_;
  out.bc(component, key, ownerComponentDef && ownerComponentDef.r_);
  return componentDef;
};